<template>
  <div class="input" v-bind:class="{ 'input--success': validPassword, 'input--error': !pristine && !password || (!pristine && match && password != match)}" style="margin-bottom: 1em;position: relative;">
    <span v-if="passwordGrade && !skipPasswordGrade" :style="{color: passwordColor, position: 'absolute', right: validPassword ? '2.5em' : '1.25em', top: '0.75em'}">{{passwordGrade}}</span>
    <input class="input__field" type="password" :placeholder="placeholder" v-model="password" ref="input" />
  </div>
</template>

<script>
let gradePassword = (password)=>{
  let score = 0;

  let grades = ['', 'weak', 'ok', 'strong', 'very strong', 'very strong'];
  let colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a', '#25a11a'];

  let hasNumbers = /\d/.test(password);
  let hasLowerCase = /[a-z]/.test(password);
  let hasUpperCase = /[A-Z]/.test(password);
  let hasSpecialCharacter = /[^a-z\d]+/i.test(password);
  let hasLength = password.length >= 8;

  if(hasNumbers) ++score;
  if(hasLowerCase) ++score;
  if(hasUpperCase) ++score;
  if(hasSpecialCharacter) ++score;
  if(hasLength) ++score;

  return {
    name: grades[score],
    color: colors[score]
  }
}

let initialPasswordState = {
  passwordGrade: null,
  passwordColor: null,
  password: null,
  validPassword: null,
  pristine: true
}

export default {
  name: 'Password',
  props: ['placeholder', 'match', 'skipPasswordGrade'],
  data(){
    let obj = {};
    for(var key in initialPasswordState) obj[key] = initialPasswordState[key];

    return obj;
  },
  methods: {
    update(){
      this.$emit('input', this.password);
    },
    resetState(){
      for(var key in initialPasswordState){
        this[key] = initialPasswordState[key];
      }
    }
  },
  watch: {
    password: function(newVal, oldVal){
      this.pristine = (newVal === '' || newVal == null);

      if(!this.skipPasswordGrade && newVal != null){
        let grade = gradePassword(newVal);

        this.passwordGrade = grade.name;
        this.passwordColor = grade.color;

        if(grade.name == 'very strong' || grade.name == 'strong'){
          this.validPassword = true;
        } else {
          this.validPassword = false;
        }
      }

      this.update();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Password.vue